// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"P3-z"};